import * as Mui from "@material-ui/core";
import { IconAddData } from "../../../../../../../components/svg";
export const NoDataFound = ({ title, subtitle, height = '55vh', buttonText, onClick, size = 'lg' }) => {
    return (
        <Mui.Box height={height} display="flex" justifyContent="center" alignItems="center">
            <Mui.Box display="flex" flexDirection="column" alignItems="center" gridGap={15}>
                <IconAddData
                    width={size === 'lg' ? 141 : 80}
                    height={size === 'lg' ? 141 : 80}
                    fill={size === 'lg' ? "#F6F6F6" : "#FFFFFF"}
                />
                <Mui.Box display="flex" flexDirection="column" alignItems="center" gridGap={5}>
                    <Mui.Typography className="font-weight-medium" variant="h5" style={{ fontSize: size === 'lg' ? 18 : 16, color: "#323239" }}>{title}</Mui.Typography>
                    <Mui.Typography className="font-weight-normal" variant="body1" style={{ color: "#9AA1A7" }}>{subtitle}</Mui.Typography>
                </Mui.Box>

                {onClick && <Mui.Button
                    className={`btn-default pl-5 pr-5 mt-2`}
                    color="primary"
                    variant="contained"
                    disableElevation
                    onClick={onClick}
                >
                    {buttonText}
                </Mui.Button>}
            </Mui.Box>
        </Mui.Box>
    )
}